/**
 * xo.center — primary public hub host (not xo.watch operator/diagnostics home).
 */

import { normalizeHostname } from "./host_root_landing";

export const XO_CENTER_HOSTS = new Set(["xo.center", "www.xo.center"]);

export function isXOCenterHost(hostname: string): boolean {
  return XO_CENTER_HOSTS.has(normalizeHostname(hostname));
}
